<!-- Lateral na medida única do projeto (`.layout-com-lateral`); sem prestador, o empty ocupa tudo. -->
<div [class.layout-com-lateral]="isPrestadorSelecionado()" class="w-full">
    @if (!isPrestadorSelecionado()) {
        <app-pesquisa [(showDialog)]="pesquisarDialog" (pessoa)="carregarPessoa($event)"></app-pesquisa>
        <app-empty
            class="w-full h-full"
            [titulo]="'Prestador não selecionado'"
            [descricao]="'Por favor, selecione um prestador para visualizar os dados'"
            [acao]="showPesquisarPessoa"
            [iconBotao]="'pi pi-search'"
            [labelBotao]="'Pesquisar Prestador'"
        ></app-empty>
    } @else {
        <div class="w-full min-w-0 pb-5">
            <app-pessoa-detalhe #pessoaDetalhe [pessoa]="pessoa()" [exibirRecuperabilidade]="false"></app-pessoa-detalhe>
        </div>
        <!--    <div class="xl:w-4/5 lg:w-4/6 md:w-full sm:w-full xs:w-full w-full sm:!w-full-revert">-->
        <div class="w-full min-w-0 max-w-full overflow-hidden">
            <div class="grid-debitos flex-grow-1">
                @if (selectedComponent === '') {
                    <!-- Sentinela: raiz sem slug e sem permissão para o default (dados-gerais). Orienta a
                         escolher uma aba pelo menu (em vez de card vazio) e oferece pesquisar outro prestador. -->
                    <app-empty
                        [titulo]="'Selecione uma funcionalidade'"
                        [descricao]="'Utilize o menu ao lado para escolher uma das opções disponíveis para este prestador.'"
                        [labelBotao]="'Pesquisar Prestador'"
                        [iconBotao]="'pi pi-search'"
                        [acao]="showPesquisarPessoa"
                    ></app-empty>
                }
                @if (selectedComponent === 'dados-gerais') {
                    <app-dados-gerais-prestador [pessoa]="pessoa()" (salvo)="pessoaDetalhe.recarregar()"></app-dados-gerais-prestador>
                }
                @if (selectedComponent === 'documentos') {
                    <app-documentos-prestador [pessoa]="pessoa()"></app-documentos-prestador>
                }
                @if (selectedComponent === 'contatos') {
                    <app-contato [pessoa]="pessoa()" [roleEditarContato]="PERMISSOES.prestadores.contatos.editar" [roleExcluirContato]="PERMISSOES.prestadores.contatos.editar"></app-contato>
                }
                @if (selectedComponent === 'diretoria') {
                    <app-diretoria-prestador [pessoa]="pessoa()"></app-diretoria-prestador>
                }
                @if (selectedComponent === 'corpo-societario') {
                    <app-corpo-societario-prestador [pessoa]="pessoa()"></app-corpo-societario-prestador>
                }
                @if (selectedComponent === 'composicao') {
                    <app-composicao-prestador [pessoa]="pessoa()"></app-composicao-prestador>
                }
                @if (selectedComponent === 'comissao-etica') {
                    <app-comissao-etica-prestador [pessoa]="pessoa()"></app-comissao-etica-prestador>
                }
                @if (selectedComponent === 'servicos-especialidades') {
                    <app-servicos-especialidades-prestador [pessoa]="pessoa()"></app-servicos-especialidades-prestador>
                }
                @if (selectedComponent === 'psmt') {
                    <app-psmt-prestador [pessoa]="pessoa()"></app-psmt-prestador>
                }
                @if (selectedComponent === 'recursos-humanos') {
                    <app-recursos-humanos-prestador [pessoa]="pessoa()"></app-recursos-humanos-prestador>
                }
                @if (selectedComponent === 'recursos-materiais') {
                    <app-recursos-materiais-prestador [pessoa]="pessoa()"></app-recursos-materiais-prestador>
                }
                @if (selectedComponent === 'atividades') {
                    <app-atividades-prestador [pessoa]="pessoa()"></app-atividades-prestador>
                }
                @if (selectedComponent === 'historico') {
                    <app-geridas-prestador [pessoa]="pessoa()"></app-geridas-prestador>
                }
                @if (selectedComponent === 'geridas') {
                    <app-gestao-geridas-prestador [pessoa]="pessoa()"></app-gestao-geridas-prestador>
                }
                @if (selectedComponent === 'anotacoes') {
                    <app-anotacoes-prestador [pessoa]="pessoa()" [roleCriar]="PERMISSOES.prestadores.anotacoes.editar" [roleExcluir]="PERMISSOES.prestadores.anotacoes.editar"></app-anotacoes-prestador>
                }
            </div>
        </div>
    }
</div>
